import { FC, useCallback, useContext, useEffect, useRef, useState } from 'react';
import styles from './postcardConstructor.module.css';
import ImageContext from '../../services/ImageContext';
import { Cropcard } from '../Cropcard/Cropcard';
import { Button, IconButton } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import LooksOneIcon from '@mui/icons-material/LooksOne';
import LooksTwoIcon from '@mui/icons-material/LooksTwo';
import Looks3Icon from '@mui/icons-material/Looks3';
import Looks4Icon from '@mui/icons-material/Looks4';
import faceForm_1 from '../../images/face_form_1.png'
import { Swiper, SwiperRef, SwiperSlide, useSwiper } from 'swiper/react'
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import SwiperCore from 'swiper';
import { Navigation, Pagination, EffectCoverflow } from 'swiper/modules';

import './swiper.css';


SwiperCore.use([Navigation, Pagination]);

interface IPostcardConstructor {
    setIsPostcard: (value: boolean) => void;
    setCroppedImages: (value: string[]) => void;
    handleTakePostcard: () => void;
}

interface ICropImage {
    id: number | null;
    status: boolean;
    croppedImage: string | null;
}

export const PostcardConstructor: FC<IPostcardConstructor> = ({setIsPostcard, setCroppedImages, handleTakePostcard}) => {
    const imgContext = useContext(ImageContext);

    // Проверяем, что контекст не undefined
    if (!imgContext) {
        throw new Error("Ошибка с Конекстом в Postcard");
    }

    const { imgNumber } = imgContext;

    const [croppedImagesId, setCroppedImagesId] = useState<ICropImage[]>([]);
    const [ localImages, setLocalImages ] = useState<string[] | null>([]);
    const [ isBtnGetPostcard, setIsBtnGetPostcard ] = useState<boolean>(false);
    const [ isBtnGetPostcardActive, setIsBtnGetPostcardActive ] = useState<boolean>(true);
    const [ isBtnNavActive, setIsBtnNavActive ] = useState<boolean>(false);

    const handleCheckCropImage = (id: number, status: boolean, croppedImage: string) => {
        const newCroppedImage: ICropImage = {
            id,
            status,
            croppedImage
        };
        setCroppedImagesId(prev => [...prev, newCroppedImage])
    };

    useEffect(() => {
        if (croppedImagesId.length > imgNumber) {
            setCroppedImagesId(croppedImagesId.slice(0, -1));
        } else if (croppedImagesId.length == imgNumber) {
            setIsPostcard(true)
            // console.log(croppedImagesId)
        // Фильтруем null и приводим к типу string[]
        const newCroppedImages: string[] = croppedImagesId
            .map(image => image.croppedImage)
            .filter((image): image is string => image !== null); // Явное приведение типа

        // console.log(newCroppedImages);
        setCroppedImages(newCroppedImages);
        } else {
            setIsPostcard(false)
        }
    }, [imgNumber, croppedImagesId]);

    useEffect(() => {
        const storedImages = localStorage.getItem('croppedImages');
        if (storedImages) {
            setLocalImages(JSON.parse(storedImages))
            // console.log(croppedImagesId)
            // console.log(localImages)
        }
        // console.log(croppedImagesId)

    }, [])

    const handleResetLocalImages = () => {
        setLocalImages(null)
        localStorage.clear()
    }

    const handleGetPostcardWithLocalImages = async() => {
        if (localImages) {
            setCroppedImages(localImages)
            setIsPostcard(true)
            setIsBtnGetPostcardActive(false)
            setIsBtnActive(true)
        }
    }

    const handleTakePostcardLocal = () => {
        handleTakePostcard()
    }

    const handleCheckDeleteImages = (imageToDelete: string) => {
        setCroppedImagesId(prevCroppedImages => 
            prevCroppedImages.filter(image => image.croppedImage !== imageToDelete)
        );
    };

    const checkScreenWidth = () => {
        setIsBtnGetPostcard(window.innerWidth < 699);
    };

    useEffect(() => {
        checkScreenWidth();

        window.addEventListener('resize', checkScreenWidth);
        return () => {
            window.removeEventListener('resize', checkScreenWidth);
        };
    }, []);

    const [ isBtnActive, setIsBtnActive ] = useState<boolean>(false);

    useEffect(() => {
        // console.log(croppedImagesId)
        if (localImages && localImages.length > 1) {
            setIsBtnActive(isBtnGetPostcardActive)
        } else {
            setIsBtnActive(croppedImagesId.length === imgNumber);
        }
    }, [localImages, croppedImagesId, isBtnGetPostcardActive, imgNumber])



    const pagination = {
        clickable: true,
        renderBullet: function (index: any, className: any) {
            return '<span class="' + className + '">' + (index + 1) + '</span>';
        }}

        const dotsNumbers = [
            <LooksOneIcon 
            className={styles.numsIcon} 
            sx={{ borderRadius: '50%', width: `${isBtnGetPostcard ? '25px' : '45px'}`, height: `${isBtnGetPostcard ? '25px' : '45px'}` }} />,
            <LooksTwoIcon 
            className={styles.numsIcon} 
            sx={{ borderRadius: '50%', width: `${isBtnGetPostcard ? '25px' : '45px'}`, height: `${isBtnGetPostcard ? '25px' : '45px'}`  }} />,
            <Looks3Icon 
            className={styles.numsIcon} 
            sx={{ borderRadius: '50%', width: `${isBtnGetPostcard ? '25px' : '45px'}`, height: `${isBtnGetPostcard ? '25px' : '45px'}`  }} />,
            <Looks4Icon 
            className={styles.numsIcon} 
            sx={{ borderRadius: '50%', width: `${isBtnGetPostcard ? '25px' : '45px'}`, height: `${isBtnGetPostcard ? '25px' : '45px'}`  }} />,
        ]

        const sliderRef = useRef<SwiperRef>(null);
        const [activeIndex, setActiveIndex] = useState<number>(0); 

        const handleSlideChange = useCallback(() => {
            if (sliderRef.current) {
                setActiveIndex(sliderRef.current.swiper.activeIndex); 
            }
        }, []);


        const handlePrev = useCallback(() => {
          if (!sliderRef.current) return;
          sliderRef?.current?.swiper?.slidePrev();
        }, []);
        const handleNext = useCallback(() => {
          if (!sliderRef.current) return;
          sliderRef?.current?.swiper?.slideNext();
        }, []);

        const handleChooseBullet = useCallback((index: number) => {
            console.log(croppedImagesId)
            if (!sliderRef.current) return;
            const swiper = sliderRef.current.swiper;
    
            if (swiper && swiper.pagination && swiper.pagination.bullets) {
                const bullet = swiper.pagination.bullets[index];
                if (bullet) {
                    bullet.click();
                } else {
                    console.error(`Bullet at index ${index} is undefined`);
                }
            } else {
                console.error("Swiper or pagination is not initialized");
            }
        }, [sliderRef]);

        const dots = Array.from({length: localImages && localImages.length > 1 ? localImages.length : imgNumber}, (_, index) => (
            <li key={index + 1} className={styles.numsIcon}>
                <IconButton 
                className={styles.numsIcon}
                sx={{ 
                    transform: index === activeIndex ? 'scale(1.4)' : '',
                    color: index === activeIndex ? '#0088d1' : ''
                 }}
                onClick={() => handleChooseBullet(index)}>
                    {dotsNumbers[index]}
                </IconButton>
            </li>
        ))

        useEffect(() => {
            if (localImages && localImages.length > 1) {
                setIsBtnNavActive(true)
            } else if (imgNumber > 1) {
                setIsBtnNavActive(true)
            } else { 
                setIsBtnNavActive(false)
            }
        }, [localImages, imgNumber])

    return (
        <div className={styles.postcard}>
            {localImages && localImages.length >= 1 ? (
                <div className={styles.localImagesContainer}>
                    <p className={styles.titlePostcard}>Создать открытку из ваших предыдущих фото?</p>
                        <div className={styles.btnContainer}>
                        <Button 
                        onClick={handleGetPostcardWithLocalImages} 
                        variant="contained"
                        >Да</Button>
                        <Button 
                        onClick={handleResetLocalImages} 
                        variant="contained"
                        sx={{fontSize: `${isBtnGetPostcard ? '0.6rem' : '0.8rem'}`}}
                        >Нет, я хочу загрузить новые фото</Button>
                        </div>
                    <ul className={styles.postcardsList}>
                        <Swiper
                        ref={sliderRef}
                        effect={'coverflow'}
                        grabCursor={true}
                        centeredSlides={true}
                        slidesPerView={'auto'}
                        onSlideChange={handleSlideChange}
                        coverflowEffect={{
                          rotate: 50,
                          stretch: 0,
                          depth: 100,
                          modifier: 1,
                          slideShadows: true,
                        }}
                        pagination={{ clickable: true}}
                        modules={[EffectCoverflow, Pagination]}
                        >                    
                        {
                        localImages.map((image, index) => (
                            <SwiperSlide virtualIndex={index} key={index}>
                            <li key={index+1} className={styles.postcardsListItem}>
                                <img style={{height: '286px'}} key={index} src={image} alt="Изображения пользователя" />
                                <img className={styles.imageCropper} src={faceForm_1} alt="Форма лица" />
                            </li>
                            </SwiperSlide>
                        ))
                        }
                        </Swiper>
                    </ul>
                </div>
            ) : (
                <ul className={styles.cropcardList}>
                <Swiper
                ref={sliderRef}
                pagination={{clickable: true}}
                modules={[ Pagination ]} 
                spaceBetween={10} 
                slidesPerView={1} 
                navigation={false}
                allowTouchMove={false}
                onSlideChange={handleSlideChange}
                >
                 {
                     Array.from({ length: imgNumber }, (_, index) => (
                        <SwiperSlide virtualIndex={index} key={index}>
                         <li className={styles.cropcardListItem}>
                             <Cropcard
                             key={index} 
                             id={index} 
                             checkCropImage={handleCheckCropImage}
                             handleCheckDeleteImages={handleCheckDeleteImages}
                             number={index+1}
                             />
                         </li>
                        </SwiperSlide>
                        ))
                 }
                    </Swiper>
                </ul> 
            )}
            <div className={styles.btnSwiperContainer}>
            {
                isBtnNavActive && (
                <ul className={styles.dotsList}>
                    {dots}
                </ul>
                )
            }
            {
                isBtnNavActive && (
                <IconButton 
                    sx={{
                        color: ' #ff7f00',
                        padding: '0'
                    }}
                    onClick={handlePrev}
                >
                    <ArrowBackIosNewIcon 
                        sx={{
                            height: '50px',
                             width: '45px'
                        }}
                    />
                </IconButton>
                )
            }
                    <Button
                sx={{
                    backgroundColor: '#74bb44',
                    border: '2px solid #FFF',
                    borderRadius: '10px',
                    display: isBtnActive ? 'inline-flex' : 'none',
                    width: '170px'
                }}
                // disabled={localImages && localImages.length > 1 ?
                // isBtnGetPostcardActive : croppedImagesId.length == imgNumber ?
                // false : true}
                style={!isBtnGetPostcard ? {display: 'none'} : {}}
                className={styles.btnCutImage} 
                variant="contained"
                onClick={handleTakePostcard}
            >
                Создать открытку
            </Button>
            {
                isBtnNavActive && (
                    <IconButton
                    sx={{
                        color: ' #ff7f00',
                        padding: '0'
                    }} 
                    onClick={handleNext}
                    >
                        <ArrowForwardIosIcon 
                        sx={{
                                height: '50px',
                                width: '45px'
                        }}
                        />
                    </IconButton>
                )
            }
            </div>
        </div>
    );
};
